// Treffer-Marker aus dem Backend (Private-Use-Bereich) → hervorgehoben rendern.
const HIGHLIGHT_PRE = '\ue000';
const HIGHLIGHT_POST = '\ue001';

/**
 * Rendert einen Fundstellen-Auszug mit hervorgehobenen Treffern. Splittet sicher
 * an den Markern (kein dangerouslySetInnerHTML) und normalisiert Whitespace.
 * Geteilt von Command-Palette und Ergebnis-Seite.
 */
export function renderSnippet(snippet: string): React.ReactNode {
  const clean = snippet.replace(/\s+/g, ' ').trim();
  return clean.split(HIGHLIGHT_PRE).map((chunk, index) => {
    if (index === 0) return <span key={index}>{chunk}</span>;
    const [match, ...rest] = chunk.split(HIGHLIGHT_POST);
    return (
      <span key={index}>
        <mark className="rounded bg-accent/25 px-0.5 font-medium text-foreground">{match}</mark>
        {rest.join(HIGHLIGHT_POST)}
      </span>
    );
  });
}
